import { Button, IconButton } from '@ui/shared/Button';
import * as React from 'react';
import { innerPopup } from '../../../data/providers/popupsProvider';
import { bulkDisable } from '../../../data/writers/test';
import { CardBody } from '../../shared/card/CardBody';
import {
  CardFooter,
  CardFooterLeft,
  CardFooterRight,
} from '../../shared/card/CardFooter';
import { CardHeader } from '../../shared/card/CardHeader';
import { FormContainer } from '../../shared/form/FormContainer';
import { LongProcessModal } from '../../shared/popups/LongProcessModal';
import {
  InnerPopupCard,
  PopupCardContent,
} from '../../shared/popups/PopupCard';

interface IProps {
  testId: string;
}

const DeleteTest = (props: IProps): React.ReactElement => {
  const closeDialog = (): void => innerPopup.next(null);

  const openDialog = (): void => {
    innerPopup.next(
      <DeletePopup onCancel={closeDialog} testId={props.testId} />
    );
  };

  return <IconButton icon='delete' onClick={openDialog} title='Delete Test' />;
};
interface IDeletePopupProps {
  onCancel: () => void;
  testId: string;
}
const DeletePopup = (props: IDeletePopupProps): React.ReactElement => {
  const { onCancel } = props;
  const [isProcessing, setIsProcessing] = React.useState<boolean>(false);
  const [completed, setCompleted] = React.useState<number>(0);

  const incrementCompleted = (): void => {
    setCompleted(completed + 1);
  };

  const onDelete = async (): Promise<void> => {
    setIsProcessing(!isProcessing);

    await bulkDisable([props.testId])
      .then((): void => {
        setIsProcessing(false);
        props.onCancel();
      })
      .catch((): void => {
        setIsProcessing(false);
      });
  };

  return (
    <InnerPopupCard noClickOutside onClose={onCancel} size='small'>
      {isProcessing ? (
        <LongProcessModal
          total={1}
          completed={completed}
          message='This can take some time to complete. If you navigate away from this page
			some tests will not be updated.'
        />
      ) : null}
      <PopupCardContent>
        <CardHeader surface={8}>
          <h5>Delete Test</h5>
        </CardHeader>
        <CardBody>
          <FormContainer>
            <p>
              Are you sure you want to delete this test? This action will
              permanently remove this test from your database and will remove
              its contribution to any populations (athlete averages, team
              averages, group averages, etc.) that this test belongs to. It
              cannot be reversed.
            </p>
          </FormContainer>
        </CardBody>
        <CardFooter>
          <CardFooterLeft>
            <Button onClick={onCancel} title='Cancel' />
          </CardFooterLeft>
          <CardFooterRight>
            <Button onClick={onDelete} title='Delete Tests' />
          </CardFooterRight>
        </CardFooter>
      </PopupCardContent>
    </InnerPopupCard>
  );
};

export { DeleteTest };
